import { FC } from "react";

import { Graphic } from "@/modules";

const GraphicPage: FC = () => {
  return (
    <div data-testid="graphic-page">
      <Graphic />
    </div>
  );
};

export default GraphicPage;
